import type { QueryFunction } from "@tanstack/react-query";
import { type CommandCenterGridRow } from "src/types/work-packets";
import { type WorkPacketType } from "../WorkPacketType";
import { fetchCommandCenterData } from "../api/workPacketsAPI";

export const getCommandCenterData: QueryFunction<
  CommandCenterGridRow[],
  ["work-packets", type: WorkPacketType, "command-center"]
> = async ({ queryKey: [, workPacketType], signal }) => fetchCommandCenterData(workPacketType, signal);
